import script from "./TaskScoringDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskScoringDialog.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=2deec5d4&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2deec5d4"]])

export default __exports__